import React, { useContext } from 'react';
import styles from './styles.css';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import Heading from '../../components/Typography/Heading/Heading';

const TrustFundingScreen = () => {
  const { back, flowProps } = useContext(FlowContext);
  const { title, options: Options } = flowProps;

  return (
    <div>
      <Heading text={title} />
      <Options />
      <div className="btn-container">
        <MFBeaconButton
          variant="secondary"
          size="normal"
          id="trustFundingBack"
          className="beacon-button-margin-override"
          onClick={back()}
          label="Back"
        />
      </div>
      <PhoneNumber />
      <style jsx>{styles}</style>
    </div>
  );
};

export default TrustFundingScreen;
